import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const ConfettiRight = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="54"
        viewBox="0 0 40 54"
        width="40"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.13837 4.0227C5.9506 3.75452 6.04167 3.49269 6.19967 3.24386C6.5642 2.66981 6.92746 2.09458 7.30873 1.53166C7.50561 1.24097 7.75566 1.13544 8.08186 1.38909C8.67477 1.85012 9.28035 2.29491 9.882 2.74465C10.2299 3.0047 10.1609 3.30491 9.95923 3.60762C9.61094 4.11164 9.31507 4.64995 9.07625 5.21414C8.88899 5.67795 8.55815 5.71251 8.15592 5.55688C7.34065 5.24143 6.78787 4.57793 6.13837 4.0227Z"
            fill="#F85520"
        />
        <path
            d="M18.5174 12.3088C19.2659 12.3295 19.7184 12.6839 19.8854 13.403C20.0901 14.2845 20.2936 15.1664 20.4841 16.051C20.544 16.3292 20.5362 16.6662 20.3042 16.8248C19.2443 17.5493 17.9683 17.4944 16.7971 17.5019C15.9353 17.5075 15.6412 16.5592 15.5404 15.7335C15.4574 15.1077 15.2995 14.4942 15.07 13.9061C14.8029 13.1965 15.1308 12.7115 15.8205 12.5896C16.7083 12.4327 17.6174 12.3968 18.5174 12.3088Z"
            fill="#FCD26A"
        />
        <path
            d="M37.0139 19.8822C36.7721 20.7313 36.2352 21.1449 35.365 21.1261C34.2983 21.103 33.2315 21.0783 32.1654 21.0381C31.8302 21.0255 31.4474 20.9184 31.3338 20.6071C30.8151 19.185 31.2498 17.7433 31.5826 16.4031C31.8275 15.417 32.9965 15.3574 33.9691 15.4829C34.7083 15.5705 35.4552 15.569 36.194 15.4782C37.0824 15.3799 37.5409 15.8959 37.4792 16.7193C37.3997 17.7793 37.1756 18.8284 37.0139 19.8822Z"
            fill="#BEB3FF"
        />
        <path
            d="M26.444 40.1798C26.2712 41.5427 25.4554 42.1591 24.0434 41.9934C22.546 41.8176 21.431 40.6144 21.5641 39.3179C21.6664 38.3213 22.9683 37.3137 23.9642 37.4604C25.7406 37.722 26.6317 38.6993 26.444 40.1798Z"
            fill="#FCD26A"
        />
        <path
            d="M12.6206 46.1709C13.733 46.3885 14.6811 46.8489 15.2534 47.9298C15.5958 48.5764 15.7143 49.1654 15.2738 49.8103C15.0838 50.0918 14.8135 50.3095 14.4981 50.4352C14.1826 50.5609 13.8366 50.5888 13.5051 50.5151C12.56 50.3833 11.686 49.9396 11.0218 49.2544C10.3984 48.5972 10.242 47.8576 10.628 47.0878C10.7878 46.7155 11.08 46.4157 11.448 46.2463C11.8161 46.077 12.2339 46.0501 12.6206 46.1709Z"
            fill="#BEB3FF"
        />
        <path
            d="M12.3812 36.5917C13.0113 32.7735 18.5767 28.5971 21.2588 29.8107C22.7439 30.4827 21.3263 32.0969 19.5526 31.8251C17.428 31.4995 16.153 30.3424 17.425 28.0107C18.733 25.6132 25.2857 21.9679 32.9287 24.5211"
            stroke="#F85520"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ConfettiRightIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={ConfettiRight}
        fontSize={fontSize}
    />
);
